import React, { useEffect, useState } from "react";
import "../styles/Gallery.css"; // Make sure to create this CSS file

const Gallery = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Set visible to true after component mounts for animation
    setTimeout(() => {
      setVisible(true);
    }, 100);
  }, []);

  return (
    <div className="gallery-container">
      <div className={`coming-soon-wrapper ${visible ? 'visible' : ''}`}>
        <h1 className="coming-soon-text">Coming Soon</h1>
        <p className="coming-soon-subtext">We're working on our gallery to showcase our vessels and operations.</p>
        <div className="gallery-placeholder">
          <div className="gallery-icon">
            <i className="fas fa-images"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;